import { Row, Col, Card, } from 'antd';
import { formatDate } from '../../../helpers/genericHelper';
import CustomText from '../../CustomText';
function BlockHistory({ blockHistory = [], userBlocked }) {

  return (
    <div style={{ maxHeight: '70vh', overflow: 'scroll' }}>
      {blockHistory && blockHistory.map((history) => {
        return (
          <Card
            key={history?.id}
            bordered={true}
            className="criclebox tablespace mb-16 card-cancel-subscription"
            style={{ position: 'relative' }}
          >
            <Row className="subscription-cancelled-card" gutter={[30, 30]}>
              <Col xs={24} sm={6} md={6} xl={6} xxl={6}>
                <h4>Status</h4>
                <CustomText dataSet={history} property1={'blockStatus'} />
              </Col>
              {history.blockStatus === 'BLOCKED' && <Col xs={24} sm={6} md={6} xl={6} xxl={6}>
                <h4>Block Code</h4>
                <CustomText dataSet={history} property1={'blockCode'} />
              </Col>}

              {history.blockStatus === 'UNBLOCKED' && <Col xs={24} sm={6} md={6} xl={6} xxl={6}>
                <h4>Unblock Code</h4>
                <CustomText dataSet={history} property1={'unblockCode'} />
              </Col>}

              <Col xs={24} sm={6} md={6} xl={6} xxl={6}>
                <h4>Date</h4>
                <CustomText dataSet={history} property1={'actionInstant'} formatter={formatDate} />
              </Col>

              <Col xs={24} sm={6} md={6} xl={6} xxl={6}>
                <h4>Reason</h4>
                <CustomText dataSet={history} property1={'additionalReason'} />
              </Col>
            </Row>
          </Card>
        )
      })}
    </div>
  );
}

export default BlockHistory;
